export default __webpack_public_path__ + "static/media/delete.6fa9634c.svg";